import { getViewNameValidationError } from "@redotech/redo-views-common/views";
import { memo, useState } from "react";
import { RedoTextInput } from "./arbiter-components/input/redo-text-input";
import {
  RedoModal,
  RedoModalButtonProps,
} from "./arbiter-components/modal/redo-modal";
import { Flex } from "./flex";
import { Text } from "./text";

export const SaveTableViewModal = memo(function SaveTableViewModal({
  cancel,
  save,
  reservedViewNames,
}: {
  save(name: string): Promise<void>;
  cancel(): void;
  reservedViewNames: Set<string>;
}) {
  const [viewName, setViewName] = useState("");

  const submitDisabledBecauseOfEmptyName =
    viewName.length === 0 ? "You must name this view" : false;
  const submitDisabledBecauseOfInvalidName =
    getViewNameValidationError(viewName) ?? false;
  const submitDisabledBecauseOfDuplicateName = reservedViewNames.has(
    viewName.toLowerCase(),
  )
    ? "A view with this name already exists"
    : false;

  const submitDisabled =
    submitDisabledBecauseOfEmptyName ||
    submitDisabledBecauseOfInvalidName ||
    submitDisabledBecauseOfDuplicateName;

  const primaryButton: RedoModalButtonProps = {
    text: "Confirm",
    onClick: async () => {
      await save(viewName);
    },
    disabled: submitDisabled,
  };

  const secondaryButton: RedoModalButtonProps = {
    text: "Cancel",
    onClick: cancel,
  };

  return (
    <RedoModal
      buttonPlacement="full"
      onModalCloseRequested={cancel}
      primaryButton={primaryButton}
      secondaryButton={secondaryButton}
      title="Save as view"
    >
      <Flex dir="column" gap="xl">
        <Flex dir="column">
          <Text>Name</Text>
          <RedoTextInput setValue={setViewName} size="md" value={viewName} />
        </Flex>
        <div data-web="SaveTableViewModal" />
      </Flex>
    </RedoModal>
  );
});
